import React from "react";
import MenuSection from "./MenuSection";
import MenuItemSeparator from "./MenuItemSeparator";
import MenuItem from "./MenuItem";

export default (props) => {
  const { item, currentUrl, layoutConfig, ktoffConvas } = props;

  return (
    <ul className="kt-menu__subnav">
      {item.submenu.map((child, index) => {
        return (
          <React.Fragment key={index}>
            {child.section && (
              <MenuSection
                item={child}
                parentItem={item}
                currentUrl={currentUrl}
              />
            )}

            {child.separator && (
              <MenuItemSeparator
                item={child}
                parentItem={item}
                currentUrl={currentUrl}
              />
            )}

            {child.title && (
              <MenuItem
                item={child}
                parentItem={item}
                currentUrl={currentUrl}
                layoutConfig={layoutConfig}
                ktoffConvas={ktoffConvas}
              />
            )}
          </React.Fragment>
        )
      })}
    </ul>
  );
}
